import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-water-chiller',
  templateUrl: './water-chiller.component.html',
  styleUrls: ['./water-chiller.component.scss']
})
export class WaterChillerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
